<div class="minesweeper">
    <div class="controls">
        <select [(ngModel)]="difficulty" (change)="setDifficulty(difficulty)">
            <option value="easy">Easy (9×9, 10 mines)</option>
            <option value="medium">Medium (16×16, 40 mines)</option>
            <option value="hard">Hard (16×30, 99 mines)</option>
        </select>
    </div>
    <div class="controls">
        <span>⏱ {{ timer }} sec</span>
        <button (click)="resetGame()">🔁 New Game</button>
    </div>
    
    <div class="board">
        <div *ngFor="let row of board; let r = index" class="row">
            <div
                *ngFor="let cell of row; let c = index"
                class="square"
                [ngClass]="{
                    revealed: cell.revealed,
                    mine: cell.revealed && cell.hasMine,
                    flagged: cell.flagged
                }"
                (click)="revealCell(r, c)"
                (contextmenu)="toggleFlag($event, r, c)">
                <ng-container *ngIf="cell.revealed">
                    <span *ngIf="!cell.hasMine && cell.adjacentMines > 0">{{ cell.adjacentMines }}</span>
                    <span *ngIf="cell.hasMine">💣</span>
                </ng-container>
                <ng-container *ngIf="!cell.revealed && cell.flagged">🚩</ng-container>
            </div>
        </div>
    </div>
    <table class="highscores" *ngIf="gameWon">
        <tr><th colspan="3">Highscores</th></tr>
        <tr>
            <th>Name</th><th>Time</th><th>Date</th>
        </tr>
        <ng-container *ngFor="let score of topScores">
            <tr *ngIf="score.score < timer">
                <td>{{ score.user }}</td><td>{{ score.score }}</td><td>{{ score.created_at | date:'yyyy-MM-dd' }}</td>
            </tr>
        </ng-container>
        <tr>
            <td></td><td>{{ timer }}</td><td></td>
        </tr>
        <ng-container *ngFor="let score of topScores">
            <tr *ngIf="score.score >= timer">
                <td>{{ score.user }}</td><td>{{ score.score }}</td><td>({{ score.created_at | date:'yyyy-MM-dd' }})</td>
            </tr>
        </ng-container>
    </table>
</div>